import script from "./WebsitesAndSocialLinksField.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsitesAndSocialLinksField.vue?vue&type=script&setup=true&lang=js"

export default script